export default __webpack_public_path__ + "static/defaultImage-7b7ecb5328dbf80f6526f03a1a8435f9.jpg";